import { useDispatch } from 'react-redux';
import NumberFormat from 'react-number-format';
import { modalsToggle } from 'actions';
import ConfirmModal from 'components/Modals/ConfirmModal';
import { useOfferAuctionBidsInfo } from 'hooks';
import { useAcceptBidMutation, useAcceptPrivateOfferMutation } from 'services/api/offer-auction';
import { OfferAuctionStatus, Vehicle } from 'types/vehicle';
import { useNoSelectorVehicleOfferAuctionById } from 'hooks';
import { ActionRow } from '../ActionRow';
import { formatCurrency } from 'utils';

type Props = {
  vehicle: Vehicle;
};

export const AdminTopOffer = ({ vehicle }: Props) => {
  const offerAuction = useNoSelectorVehicleOfferAuctionById(vehicle.id);

  const dispatch = useDispatch();
  const handleAccept = () => dispatch(modalsToggle(`acceptTopOffer`));
  const { highestBidOffer } = useOfferAuctionBidsInfo(offerAuction);

  const buyerAmount = (() => {
    if (offerAuction?.status !== OfferAuctionStatus.PRIVATE_BIDS) {
      return 0;
    }

    return offerAuction?.privateOffers?.find(el => el.sender.role === 'buyer')?.amount ?? 0;
  })();

  const [acceptBid] = useAcceptBidMutation();
  const [acceptOffer] = useAcceptPrivateOfferMutation();

  if (!offerAuction || !highestBidOffer || highestBidOffer.bidder.is_bot) {
    return null;
  }

  const offerAmount = Math.max(buyerAmount, highestBidOffer.amount);
  const offerFrom = (() => {
    if (buyerAmount > highestBidOffer.amount) {
      return offerAuction?.topBidder?.dealership_name ?? '';
    }
    return highestBidOffer.bidder?.dealership_name ?? '';
  })();

  const handleAcceptBid = () => {
    if (buyerAmount >= highestBidOffer.amount) {
      acceptOffer({ vehicleId: offerAuction.vehicle_id });
    } else {
      acceptBid({ offer_id: highestBidOffer.id, vehicle_id: offerAuction.vehicle_id });
    }
    dispatch(modalsToggle(`acceptTopOffer`));
  };

  if (offerAmount === 0) return null;

  return (
    <>
      <ActionRow
        label={`Top Offer - ${formatCurrency(offerAmount)}`}
        buttonConfig={{
          handleClick: handleAccept,
          label: 'Accept Offer'
        }}
      />
      <ConfirmModal
        modalId={'acceptTopOffer'}
        title={
          <>
            You are about to accept the offer of{' '}
            <NumberFormat displayType="text" prefix="$" value={offerAmount} thousandSeparator />
            from {offerFrom}
            {/* {` ${highestBidOffer.bidder.dealership_name ?? ''}`} */}
          </>
        }
        submitText={'Confirm'}
        handleSubmit={handleAcceptBid}
      />
    </>
  );
};
